import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        buttonState: {
            unlink: 'Unlink',
            link: 'Link to Facebook',
            loading: 'Loading...'
        }
    },
    es: {
        buttonState: {
            unlink: 'Desinstalar',
            link: 'Instalar a Facebook',
            loading: 'Cargando...'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/molecules/ItemBlock/ItemBlockContent.js